import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Content } from '../../../components/dashboard/Content';
import { Sidebar } from '../../../components/dashboard/Sidebar';
import { DashboardContainer } from '../Dashboard';
import { _AddPost } from '../../../store/actions/blogAction';

export const AddPost = () => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [contentsState, setContentsState] = useState('');
  const [featuredImage, setFeaturedImage] = useState('');

  const dispatch = useDispatch();
  const user = useSelector((state) => state.adminAuth.user);

  const FILE_SIZE = 2000000;
  const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

  const filesharhe_ref = useRef();

  const AddPostSchema = Yup.object().shape({
    title: Yup.string().required('Enter Post Title'),
    featured_image: Yup.mixed()
      .test('FILE_SIZE', 'Uploaded file is too big.', (value) => {
        return value && filesharhe_ref.current
          ? filesharhe_ref.current.files[0].size <= FILE_SIZE
            ? true
            : false
          : true;
      })
      .test(
        'SUPPORTED_FORMATS',
        'Unsupported file format. Please upload a jpg, jpeg or png file.',
        (value) => {
          return value && filesharhe_ref.current
            ? SUPPORTED_FORMATS.includes(filesharhe_ref.current.files[0].type)
              ? true
              : false
            : true;
        }
      ),
    category: Yup.string().required('Select Category'),
    tags: Yup.string().required('Select Tags, seperate with comma'),
  });

  return (
    <DashboardContainer>
      <div className='wrap'>
        <Sidebar />
        <Content title='ADD POST'>
          <EditorStyle>
            <div className='post__editor'>
              <Formik
                initialValues={{
                  title: '',
                  category: '',
                  tags: '',
                }}
                encType='multipart/form-data'
                validationSchema={AddPostSchema}
                onSubmit={(values, { setSubmitting }) => {
                  const data = new FormData();
                  data.append('title', values.title);
                  data.append('category', values.category);
                  data.append('featuredImage', featuredImage);
                  data.append('tags', values.tags);
                  data.append('contents', contentsState);

                  dispatch(_AddPost(data, user._id));
                  setSubmitting(false);
                }}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form encType='multipart/form-data'>
                    <div className='inputs'>
                      <label htmlFor='title'>Title</label>
                      <Field name='title' className='field_style' />
                      {errors.title && touched.title ? (
                        <div className='error'>{errors.title}</div>
                      ) : null}
                    </div>
                    <div className='inputs'>
                      <label htmlFor='title'>Featured Image</label>
                      <Field
                        id='file'
                        name='featuredImage'
                        type='file'
                        accept='image/*'
                        className='field_style'
                        // value={featuredImage}
                        onChange={(event) => {
                          setFeaturedImage(event.target.files[0]);
                        }}
                      />

                      {errors.featured_image && touched.featured_image ? (
                        <div className='error'>{errors.featured_image}</div>
                      ) : null}
                    </div>
                    <div className='inputs'>
                      <label htmlFor='title'>Category:</label>
                      <Field
                        name='category'
                        type='text'
                        className='field_style'
                      />
                      {errors.category && touched.category ? (
                        <div className='error'>{errors.category}</div>
                      ) : null}
                    </div>
                    <div className='inputs'>
                      <label htmlFor='title'>Tags</label>
                      <Field name='tags' type='text' className='field_style' />
                      {errors.tags && touched.tags ? (
                        <div className='error'>{errors.tags}</div>
                      ) : null}
                    </div>
                    <br />
                    <div className='inputs'>
                      <Editor
                        editorState={editorState}
                        toolbarClassName='toolbarClassName'
                        wrapperClassName='wrapperClassName'
                        editorClassName='editorClassName'
                        spellCheck={true}
                        placeholder='Start writing post here !!!'
                        onEditorStateChange={(newState) => {
                          setEditorState(newState);
                          setContentsState(
                            draftToHtml(
                              convertToRaw(newState.getCurrentContent())
                            )
                          );
                        }}
                        hashtag={{
                          separator: ' ',
                          trigger: '#',
                        }}
                      />
                    </div>
                    <div className='inputs'>
                      <label htmlFor='Preview'>Preview</label>
                      <div className='preview'>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: contentsState,
                          }}
                        />
                      </div>
                    </div>
                    <br />
                    <button
                      type='submit'
                      disabled={isSubmitting}
                      className='button'
                    >
                      Create Post
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </EditorStyle>
        </Content>
      </div>
    </DashboardContainer>
  );
};

const EditorStyle = styled.main`
  .toolbarClassName {
    background: ${({ theme }) => theme.pale};
    color: ${({ theme }) => theme.dark};
  }

  .wrapperClassName {
    background: ${({ theme }) => theme.pale};
    border-radius: 9px;
  }

  .editorClassName {
    padding: 10px;
    color: ${({ theme }) => theme.a};
  }

  .inputs {
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .field_style {
    border: 1px solid ${({ theme }) => theme.dark};
    border-radius: 5px;
    padding: 10px;
    width: 100%;
  }

  .preview {
    background: ${({ theme }) => theme.pale};
    border-radius: 9px;
    padding: 10px;
    width: 100%;
  }

  .button {
    background: ${({ theme }) => theme.svg};
    border: 1px solid ${({ theme }) => theme.dark};
    border-radius: 5px;
    color: ${({ theme }) => theme.overlay};
    padding: 15px;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .error {
    color: tomato;
    font-size: 15px;
    margin-top: 5px;
  }
`;
